import { LOCAL_STORAGE_KEY } from "../Enums";
import {
  graphAPIRequest,
  msalInstance,
  customerSvcLoginRequest,
  kulcsUzletLoginRequest,
} from "./AuthProvider";

export const handleCustomerSvcLogin = async () => {
  await msalInstance
    .handleRedirectPromise()
    .then(() => {
      msalInstance.loginRedirect(customerSvcLoginRequest).catch(() => {
        localStorage.clear();
        sessionStorage.clear();
      });
    })
    .catch((error) => {
      if (error.errorCode === "server_error") {
        error.errorMessage.includes("AADB2C99002")
          ? console.log(error.errorMessage)
          : console.log(error.errorMessage);
      } else console.log(error.errorMessage);
    });
};
export const handleKulcsUzletSvcLogin = async () => {
  await msalInstance
    .handleRedirectPromise()
    .then(() => {
      msalInstance.loginRedirect(kulcsUzletLoginRequest).catch(() => {
        localStorage.clear();
        sessionStorage.clear();
      });
    })
    .catch((error) => {
      if (error.errorCode === "server_error") {
        error.errorMessage.includes("AADB2C99002")
          ? console.log(error.errorMessage)
          : console.log(error.errorMessage);
      } else console.log(error.errorMessage);
    });
};

export const handleGraphApiLogin = async () => {
  await msalInstance.loginRedirect(graphAPIRequest);
  await msalInstance
    .handleRedirectPromise()
    .then(() => {
      msalInstance.loginRedirect(graphAPIRequest).catch((e) => {
        console.log(e);
      });
    })
    .catch((error) => {
      console.log(error);
    });
};

export const handleLogout = () => {
  const logoutRequest = {
    account: msalInstance.getActiveAccount(),
    postLogoutRedirectUri: "/",
  };

  msalInstance
    .logoutRedirect(logoutRequest)
    .then(() => {
      localStorage.removeItem(LOCAL_STORAGE_KEY.MS_AUTH_TOKEN);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const acquireTokenCustomerSvc = async () => {
  const request = {
    ...customerSvcLoginRequest,
    account: msalInstance.getAllAccounts()[0],
  };
  return msalInstance
    .acquireTokenSilent(request)
    .then((response) => {
      return response.accessToken;
    })
    .catch(() => {
      msalInstance.acquireTokenRedirect(request).catch(() => {
        handleLogout();
      });
    });
};
export const acquireTokenKulcsuzlet = async () => {
  const account =
    msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  const request = {
    ...kulcsUzletLoginRequest,
    account,
  };
  return msalInstance
    .acquireTokenSilent(request)
    .then((response) => {
      return response.accessToken;
    })
    .catch((error) => {
      msalInstance.acquireTokenRedirect(request).catch(() => {
        handleLogout();
      });

      // Do not let API calls continue with an undefined token.
      throw error;
    });
};

export const acquireGraphApiToken = async () => {
  const request = {
    ...graphAPIRequest,
    account: msalInstance.getAllAccounts()[0],
  };
  return msalInstance
    .acquireTokenSilent(request)
    .then((response) => {
      return response.accessToken;
    })
    .catch(() => {
      msalInstance.acquireTokenRedirect(request).catch((error) => {
        return null;
      });
    });
};
